module.exports = __webpack_public_path__ + "img/locale2.ab590124.png";